import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/applicationuns')({
  beforeLoad: () => {
    throw redirect({ to: '/' })
  },
})
